import { Box, TextButton } from '@zillow/constellation-10';
import { IconPlusFilled } from '@zillow/constellation-icons';
import { useFieldArray } from 'react-hook-form';
import { MAX_DOGS } from '../../../../constants/form';
import { EMPTY_DOG } from '../../../../utils/application-edit';
import { DOGS_FIELD_ARRAY_NAME, DogEdit } from './DogEdit';

export function DogsList() {
  const { fields, append, remove } = useFieldArray({ name: DOGS_FIELD_ARRAY_NAME });

  return (
    <Box css={{ display: 'flex', flexDirection: 'column', gap: 'default', marginTop: 'default' }}>
      {fields.map((dog, index) => (
        <DogEdit key={dog.id} index={index} onDelete={() => remove(index)} />
      ))}
      {fields.length < MAX_DOGS && (
        <TextButton
          type="button"
          icon={<IconPlusFilled />}
          onClick={() => append(EMPTY_DOG)}
          css={{ alignSelf: 'center' }}
        >
          Add dog
        </TextButton>
      )}
    </Box>
  );
}
